
  var _styles = {
  "reward-records-header": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.53333rem",
    "marginBottom": "0.42667rem",
    "width": "10rem",
    "position": "relative",
    "height": "0.74453rem"
  },
  "task-list-container": {
    "flex": 1,
    "paddingTop": 0,
    "paddingRight": "0.48rem",
    "paddingBottom": 0,
    "paddingLeft": "0.48rem",
    "marginTop": "0.96rem"
  },
  "task-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "backgroundColor": "rgba(255,255,255,0.9)",
    "borderRadius": "0.32rem",
    "marginBottom": "0.32rem"
  },
  "task-icon": {
    "width": "1.41333rem",
    "height": "1.41333rem",
    "borderRadius": "0.70667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginRight": "0.32rem",
    "flexShrink": 0
  },
  "task-content": {
    "flex": 1
  },
  "task-title-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginBottom": "0.10667rem"
  },
  "task-title": {
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "color": "rgb(17,17,17)",
    "marginRight": "0.10667rem",
    "fontFamily": "PingFang SC"
  },
  "task-progress": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.42667rem",
    "color": "rgb(85,85,85)",
    "fontWeight": "400"
  },
  "task-desc": {
    "fontSize": "0.26667rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400"
  },
  "task-action": {
    "flexShrink": 0
  },
  "task-btn": {
    "width": "1.93333rem",
    "height": "0.8rem",
    "borderRadius": "0.4rem",
    "borderWidth": "none",
    "borderColor": null,
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "fontSize": "0.37333rem",
    "fontWeight": "600",
    "backgroundColor": "gold"
  },
  "task-btn-text": {
    "color": "rgb(51,51,51)",
    "fontSize": "0.37333rem",
    "fontWeight": "600"
  },
  "task-join-team-btn": {
    "borderWidth": "0.02667rem",
    "borderStyle": "#f0f0f0",
    "borderColor": null
  }
};



  module.exports = _styles;
  